export const EnumValue = {
  print: ({ node }) => node.name
};
